import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConstantsService } from '../constant/constants.service';
import { ImportResponse } from 'src/app/shared/models/api-response/import-response';
import { GenericCrudService } from '../generic-crud.service';
import { HttpHeaders } from '@angular/common/http';
import { Prestation } from 'src/app/shared/models/prestation';

@Injectable({
	providedIn: 'root'
})
export class CapaciteService {
	constructor(
		private appConstants: ConstantsService,
		private genericCrudService: GenericCrudService
	) {}

	getAllCapacite(): Observable<Prestation[]> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.capaciteUrl}/all`,
			'getAllCapacite'
		);
	}


	getCapaciteById(id: number): Observable<Prestation> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.capaciteUrl}/get/${id}`,
			'getCapaciteById'
		);
	}

	updateCapacite(capacite: Prestation): Observable<void> {
		return this.genericCrudService.genericPutDataToAPI(
			`${this.appConstants.capaciteUrl}/update/${capacite.id}`,
			'updateCapacite',
			capacite
		);
	}

	addCapacite(capacite: Prestation): Observable<void> {
		return this.genericCrudService.genericPostDataToAPI(
			`${this.appConstants.capaciteUrl}/add`,
			'addCapacite',
			capacite
		);
	}

	deleteCapacite(capaciteId: number): Observable<void> {
		return this.genericCrudService.genericDeleteAPIDataByID(
			`${this.appConstants.capaciteUrl}/delete/${capaciteId}`,
			`deleteCapacite`
		);
	}

}
